import { DatePipe } from '@angular/common';
import { Component, computed, input, signal } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import { IonItem, IonLabel, IonIcon, IonDatetime } from '@ionic/angular/standalone';

import { DATE_DISPLAY_FORMAT } from '@core/utils/date-format.util';

@Component({
  selector: 'x-date-picker',
  standalone: true,
  imports: [ReactiveFormsModule, IonItem, IonLabel, IonIcon, IonDatetime, DatePipe],
  templateUrl: './x-date-picker.component.html',
  styleUrl: './x-date-picker.component.scss',
})
export class XDatePickerComponent {
  protected readonly DATE_DISPLAY_FORMAT = DATE_DISPLAY_FORMAT;

  label = input.required<string>();
  control = input.required<FormControl<string | null>>();
  min = input<string | undefined>(undefined);
  max = input<string | undefined>(undefined);
  errorMessages = input<Record<string, string>>({});

  protected isOpen = signal(false);
  protected displayValue = signal<string | null>(null);

  protected readonly currentValue = computed(() => {
    return this.displayValue() ?? this.control().value;
  });

  protected readonly presentationValue = computed(() => {
    return this.currentValue() ?? new Date().toISOString().split('T')[0];
  });

  openPicker(): void {
    this.displayValue.set(this.control().value);
    this.isOpen.set(true);
  }

  onDateChanged(event: CustomEvent): void {
    const value = event.detail.value as string;
    const dateOnly = value.split('T')[0];
    this.control().setValue(dateOnly);
    this.control().markAsTouched();
    this.displayValue.set(dateOnly);
    this.isOpen.set(false);
  }

  onCancel(): void {
    this.isOpen.set(false);
  }

  getErrorMessage(): string | null {
    const ctrl = this.control();
    if (!ctrl?.errors || !ctrl.touched) {
      return null;
    }

    const errors = this.errorMessages();
    const errorKey = Object.keys(ctrl.errors)[0];
    return errors[errorKey] || `Invalid ${this.label().toLowerCase()}`;
  }
}
